import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { Stack, Typography } from '@mui/material';
import { getLocalDate } from '@surfline/web-common';

import styles from './CurrentDateTime.module.scss';

interface Props {
  abbrTimezone: string;
  displayFormat?: string;
  label?: string;
  utcOffset: number;
}

const CurrentDateTime: React.FC<Props> = ({
  abbrTimezone,
  displayFormat = 'h:mmaaa',
  label = 'Local time:',
  utcOffset,
}) => {
  const [dateTimeLabel, setDateTimeLabel] = useState('');
  const [isMounted, setIsMounted] = useState(false);

  const updateTimestamp = useCallback(() => {
    const localTimestamp = getLocalDate(new Date().getTime() / 1000, utcOffset);
    setDateTimeLabel(format(localTimestamp, displayFormat));
  }, [displayFormat, utcOffset]);

  useEffect(() => {
    setIsMounted(true);
    updateTimestamp();
    const refreshTimer = setInterval(() => {
      updateTimestamp();
    }, 1000);
    return () => {
      clearInterval(refreshTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack direction="row" data-testid="current-datetime">
      <Typography component="span" className={styles.localTimeLabel} variant="callout2">
        {label}
      </Typography>
      {isMounted && (
        <Typography
          component="span"
          className={styles.localTimeLabel}
          variant="callout2"
        >{`${dateTimeLabel}, ${abbrTimezone} (UTC${
          utcOffset >= 0 ? '+' : ''
        }${utcOffset})`}</Typography>
      )}
    </Stack>
  );
};

export default CurrentDateTime;
